import { render } from "./writein-row.vue?vue&type=template&id=76fa2998"
import script from "./writein-row.vue?vue&type=script&lang=js"
export * from "./writein-row.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__